import { getScoreColor } from '../helpers';

interface MiniKpiBarProps {
  label: string;
  score: number;
  variant: 'horizontal' | 'stacked';
}

export default function MiniKpiBar({ label, score, variant }: MiniKpiBarProps) {
  const color = getScoreColor(score);
  const bar = (
    <div className="h-0.5 flex-1 overflow-hidden rounded-full bg-border">
      <div
        className="h-full rounded-full"
        style={{ width: `${(score / 99) * 100}%`, backgroundColor: color }}
      />
    </div>
  );

  if (variant === 'horizontal') {
    return (
      <div className="flex items-center gap-1">
        <span className="text-[7px] font-bold" style={{ color }}>
          {score}
        </span>
        <span className="text-[7px] text-muted-foreground">{label}</span>
        {bar}
      </div>
    );
  }

  return (
    <div>
      <div className="mb-0.5 flex items-center justify-between">
        <span className="text-[7px] text-muted-foreground">{label}</span>
        <span className="text-[7px] font-semibold" style={{ color }}>
          {score}
        </span>
      </div>
      <div className="h-0.5 overflow-hidden rounded-full bg-border">
        <div
          className="h-full rounded-full"
          style={{ width: `${(score / 99) * 100}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
}
